import { ApiError } from '../api/index.ts';

export function actionError(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.isNetworkError) return 'Cannot reach the server. Try again.';
    if (e.isRateLimited) return 'Too many attempts, wait a moment.';
    return e.message;
  }
  return 'Something went wrong. Try again.';
}
